"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("./context");
const hooks_1 = require("./hooks");
const constants_1 = require("./constants");
const FeaturesList_1 = require("./FeaturesList");
const PersonasList_1 = require("./PersonasList");
const UsecasesList_1 = require("./UsecasesList");
const Header_1 = require("./Header");
const react_2 = require("@osmosys/react");
const react_if_1 = require("react-if");
exports.FeatureDemo = ({ usecase = 'ads', allowUsecaseChange = true, showHeader = true, }) => {
    const [state, dispatch] = hooks_1.useFeatureDemoReducer(usecase
        ? {
            usecase,
        }
        : undefined);
    const features = react_1.useMemo(() => state.persona
        ? constants_1.FEATURE_CONFIG.usecases[state.usecase].filter(f => f.personas.includes(state.persona))
        : constants_1.FEATURE_CONFIG.usecases[state.usecase], [state.persona]);
    return (react_1.default.createElement(context_1.FeatureDemoContext.Provider, { value: {
            dispatch,
            features,
            state,
        } },
        react_1.default.createElement(react_2.OsmosysDiv, { flexColFilled: true },
            react_1.default.createElement(react_if_1.When, { condition: showHeader === true },
                react_1.default.createElement(Header_1.FeatureDemoHeader, null)),
            react_1.default.createElement(react_if_1.When, { condition: allowUsecaseChange === true },
                react_1.default.createElement(UsecasesList_1.FeatureDemoUsecasesList, null)),
            react_1.default.createElement(PersonasList_1.FeatureDemoPersonasList, null),
            react_1.default.createElement(FeaturesList_1.FeatureDemoFeaturesList, null))));
};
exports.default = exports.FeatureDemo;
//# sourceMappingURL=index.js.map